import { Component, OnInit } from '@angular/core';
import { TFindSimplePathFixedLengthGraph } from './t-find-simple-path-fixed-length-graph';
import { GraphService } from '../../General/graph/graph.service';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { GraphGenerator } from '../../General/graph/graph-generator';
import { GraphAlgorithm } from '../../General/graph/graph-algorithm';
import { TreeWords } from './tree-words';
import { Node } from '../../General/graph/lib/node';
import { TreeService } from '../../General/Tree/tree.service';
import { TeacherGraphExerciseComponent } from '../../shared/interactive-graph/exercise_components/teacher-graph-exercise.component';
import { AbstractNode } from 'graph-interactive/dist/lib/abstract/aNode';
import { NameVertex, GraphServiceJson, GraphRandom } from 'graph-interactive';
import { GraphUU } from '../../shared/interactive-graph/simple_graphs/graphUU';
import { InteractiveGraph } from 'graph-interactive/dist/lib/interactive/interactiveGraph';

@Component({
  selector: 'app-t-find-valid-path',
  templateUrl: './t-find-valid-path.component.html',
  styleUrls: ['./t-find-valid-path.component.css']
})
export class TFindValidPathComponent extends TeacherGraphExerciseComponent {

  private tree: TreeWords = null;
  private canvas: HTMLCanvasElement = null;
  private treeCanvas: HTMLCanvasElement = null;
  private generateTreeButton: HTMLButtonElement = null;


  private readonly canvasID: string = 'graph-canvas';
  private readonly treeCanvasID: string = 'tree-canvas';
  private readonly generateTreeID: string = 'generateTree';

  private readonly graphService: GraphService;
  private readonly treeService: TreeService;
  private readFromConfig = false;
  private hasBuilt: boolean = false;

  constructor(protected topicsService: TopicService, protected activatedRoute: ActivatedRoute, graphService: GraphService, treeService: TreeService) {
    super(topicsService, activatedRoute);
    this.type = 'findValidPath';
    this.title = this.get('findValidPath');
    this.graphService = graphService;
    this.treeService = treeService;
    this.description = this.get('descriptionFindValidPath');

  }

  
  generate(){
    GraphRandom.generateGraph(this.graph);
  }
  
  initGraph(): InteractiveGraph {
    // tslint:disable-next-line: max-line-length
    const canvas = <HTMLCanvasElement>document.getElementById(this.canvasID); //Call this on ngOnInit(), the constructor can't reference it, since it hasn't been initialized
    const graph: GraphUU = new GraphUU(canvas)
    return graph;
  }



  ngOnInit() {
    super.ngOnInit();
    window.onload = function () { };
    this.canvas = <HTMLCanvasElement>document.getElementById(this.canvasID); //Call this on ngOnInit(), the constructor can't reference it, since it hasn't been initialized
    this.treeCanvas = <HTMLCanvasElement>document.getElementById(this.treeCanvasID);
    this.generateTreeButton = <HTMLButtonElement>document.getElementById(this.generateTreeID);
    this.generateTreeButton.addEventListener('click', this.generateTree, false);
  }


  generateTree = () => {
    if (this.graph.getGraph().getNodes().length == 0)
      return;
    this.hasBuilt = true;
    let prefixNodes: AbstractNode[] = this.graph.getPrefixNodes();
    let alphabets: [any[], number][] = [];
    prefixNodes.forEach(node => {
      if (node instanceof NameVertex) {
        let alph: string[] = [node.getName()];
        alphabets.push([alph, 1]);
      }
    })
    let allNodes: AbstractNode[] = this.graph.getGraph().getNodes();
    let alph: string[] = [];
    allNodes.forEach(node => {
      if (node instanceof NameVertex) {
        alph.push(node.getName());
      }
    })
    if (alph.length >= 5) {
      alph = [];
      let randomNodes: AbstractNode[] = [];
      while (randomNodes.length < 5) {
        let index: number = Math.floor(Math.random() * allNodes.length);
        let n: AbstractNode = allNodes[index];
        if (!randomNodes.includes(n)) {
          randomNodes.push(n);
        }
      }
      if (prefixNodes.length > 0) {
        let r1: AbstractNode = prefixNodes[prefixNodes.length - 1];
        let r2: AbstractNode = null;
        for (let i = 0; i < this.getNeighbors(r1).length; i++) {
          let neighbor: AbstractNode = this.getNeighbors(r1)[i];
          if (!prefixNodes.includes(neighbor)) {
            r2 = neighbor;
            break;
          }
        }
        if (r2 != null) {
          let x: number = Math.floor(Math.random() * 5);
          let hasR2: boolean = false;
          randomNodes.forEach(r => {
            if (r == r2) {
              hasR2 = true;
            }
          })
          if (!hasR2)
            randomNodes[x] = r2;
          let r3: AbstractNode = null;
          for (let i = 0; i < this.getNeighbors(r2).length; i++) {
            let neighbor: AbstractNode = this.getNeighbors(r2)[i];
            if (!prefixNodes.includes(neighbor)) {
              r3 = neighbor;
              break;
            }
          }
          if (r3 != null) {
            let y = 0;
            while (y == x) {
              y = Math.floor(Math.random() * 5);
            }
            let hasR3: boolean = false;
            randomNodes.forEach(r => {
              if (r == r3) {
                hasR3 = true;
              }
            })
            if (!hasR3)
              randomNodes[y] = r3;
          }
        }

      }
      randomNodes.forEach(n => {
        if (n instanceof NameVertex)
          alph.push(n.getName());
      });
    }
    alphabets.push([alph, 2]);

    this.tree = new TreeWords(alphabets, false, this.treeCanvas);
    this.tree.buildTree();
    this.tree.generateSimplePaths();

  }

  getNeighbors(origin: AbstractNode): AbstractNode[] {
    let neighbors: AbstractNode[] = [];
    this.graph.getGraph().getEdges().forEach(edge => {
      if (edge.getStartNode() == origin) {
        neighbors.push(edge.getEndNode());
      }
    });
    return neighbors;
  }



  generateDefinition(): any {
    if (!this.hasBuilt) {
      this.generateTree();
    }
    const definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = './assets/images/validPaths.png';
    definition.key = 'findValidPath%'.concat(this.type, '%' + this.id);
    if (this.examId > -1) {
      definition.key = definition.key.concat('exam%', this.examId.toString(), '%');
    }
    GraphServiceJson.exportGraph(this.graph, definition);
    this.treeService.exportTree(this.tree, definition, true);
    if (this.tree.getSubNode() != null) {
      this.treeService.exportSubTreeNode(this.tree.getSubNode(), definition);
    }
    return definition;
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.hasBuilt = true;
    this.canvas = <HTMLCanvasElement>document.getElementById(this.canvasID);
    this.treeCanvas = <HTMLCanvasElement>document.getElementById(this.treeCanvasID);
    this.generateTreeButton = <HTMLButtonElement>document.getElementById(this.generateTreeID);

    //If we load from configfile we dont need to create a new empty graph
    if (!this.readFromConfig) {
      this.generateTreeButton.addEventListener('click', this.generateTree, false);
    }

    this.treeCanvas = <HTMLCanvasElement>document.getElementById(this.treeCanvasID);
    let alphabet: [any[], number][] = this.treeService.importMultiTree(this.configuration);
    let hasRep: boolean = this.treeService.importHasRepetition(this.configuration);
    this.tree = new TreeWords(alphabet, hasRep, this.treeCanvas);
    this.tree.buildTree();


    let rootContent: any[] = this.treeService.importSubNode(this.configuration);
    if (rootContent.length > 0) {
      if (this.tree instanceof TreeWords) {
        this.tree.setSubNode(rootContent);
      }
    }
    this.tree.generateSimplePaths();
    this.tree.update();
    this.readFromConfig = true;
  }

}



